module.exports = __webpack_public_path__ + "ddc162eef831baf2bbfd2de624bfacab.svg";